import React, { useState, useEffect, useContext } from 'react';
import { MainSettingsContext } from '../App.js';
import Navbutton from './components/Navbutton.js';

export default function Faq() {

    const { locationAndDates } = useContext(MainSettingsContext);

    return (

        <>

            <section className="main-sec">
                <header className="header">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <img src="assets/images/logo.svg" alt="" />
                        </div>
                        <div className="col-md-6">
                            <h2>Workshop Agenda</h2>
                            <p>{locationAndDates}</p>
                        </div>
                    </div>
                </header>
				<div className="main-container">
					<h1 className="main-heading">Frequently Asked Questions</h1>
					<div className="main-card">
                        <div className="accordion" id="faqAccordion">
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingOne">
                                    <button
                                        className="accordion-button"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                    >
                                        Where can I see who requested an appointment?
                                    </button>
                                </h2>
                                <div
                                    id="collapseOne"
                                    className="accordion-collapse collapse show"
                                    aria-labelledby="headingOne"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        In your <strong>Agenda</strong> you can see all{" "}
                                        <strong>confirmed</strong> appointments.
                                        <br />
                                        In <strong>Your activity</strong> you will find all the appointment
                                        requests you have sent and their status.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingTwo">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo"
                                        aria-expanded="false"
                                        aria-controls="collapseTwo"
                                    >
                                        How do I check the status of a request?
                                    </button>
                                </h2>
                                <div
                                    id="collapseTwo"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingTwo"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        If a request is confirmed, it appears directly in your{" "}
                                        <strong>Agenda</strong>.<br />
                                        For a full list of requests you've sent and their current status, open{" "}
                                        <strong>Your activity</strong>.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingThree">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree"
                                        aria-expanded="false"
                                        aria-controls="collapseThree"
                                    >
                                        How can I prompt a partner to confirm?
                                    </button>
                                </h2>
                                <div
                                    id="collapseThree"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingThree"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        You can send a <strong>new appointment request</strong> to the selected
                                        partner for the desired time slot.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingFour">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseFour"
                                        aria-expanded="false"
                                        aria-controls="collapseFour"
                                    >
                                        Can I cancel an appointment that is in "pending" status?
                                    </button>
                                </h2>
                                <div
                                    id="collapseFour"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingFour"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        <em>Pending</em> means the appointment hasn't been confirmed yet.
                                        <br />
                                        If you choose to <strong>decline</strong>, your partner will be
                                        notified.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingFive">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseFive"
                                        aria-expanded="false"
                                        aria-controls="collapseFive"
                                    >
                                        Where can I find the complete list of Buyers?
                                    </button>
                                </h2>
                                <div
                                    id="collapseFive"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingFive"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        Go to <strong>Partner Search</strong> to see the list of accredited
                                        companies that will attend the Workshop and with whom you can book
                                        meetings.
                                        <br />
                                        You can also <strong>hide contacts</strong> with whom you already have
                                        an appointment to make the search easier.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingSix">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseSix"
                                        aria-expanded="false"
                                        aria-controls="collapseSix"
                                    >
                                        How do I replace a "pending" appointment?
                                    </button>
                                </h2>
                                <div
                                    id="collapseSix"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingSix"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        <strong>Decline</strong> the request you don't want to confirm, then
                                        look for other partners to fill that free time slot.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingSeven">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseSeven"
                                        aria-expanded="false"
                                        aria-controls="collapseSeven"
                                    >
                                        When can I rate a Buyer?
                                    </button>
                                </h2>
                                <div
                                    id="collapseSeven"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingSeven"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        If you are a <strong>Seller</strong>, once a scheduled meeting with a
                                        Buyer has been completed, you will be able to rate them using a{" "}
                                        <strong>star system</strong> to share your feedback.
                                    </div>
                                </div>
                            </div>
                        </div>
						
					</div>
				</div>
                <footer className="footer">
                    <ul>
                        <li>&copy; {new Date().getFullYear()} - PromAx Communication SA - <a target="_blank" rel="noreferrer" href='http://www.sihe.ch'>www.sihe.ch</a><br></br>Tel. 0041/91/6118070 - <a href="mailto:segreteria@sihe.ch">segreteria@sihe.ch </a></li>
                    </ul>
                </footer>
            </section>

            <Navbutton></Navbutton>

        </>
    );

}